module.exports = __webpack_public_path__ + "static/media/Logo.5045683e.png";